import { ENV } from '@/lib/config/env';
import { client as inferenceClient } from '@inference.engine/api-client/web';

import { configureApiClient } from './configure-client';

if (!ENV.INFERENCE_ENGINE_API_BASE_URL) {
  throw new Error('INFERENCE_ENGINE_API_BASE_URL environment variable is not set');
}

export const inferenceHttp = configureApiClient(inferenceClient, ENV.INFERENCE_ENGINE_API_BASE_URL);
